import {
  MasterArtworkPrintingTechniqueActionType,
  MasterArtworkPrintingTechniqueActionTypes,
  MasterArtworkPrintingTechniqueState,
} from "./data.type";
import { IMasterArtworkRequestHistory } from "../collections/data.type";
import { MasterArtworkNumberActionTypes } from "../artwork-number/data.type";

const initialState: MasterArtworkPrintingTechniqueState = {
  id: undefined,
  name: "",
  code: undefined,
  decoration_technique: null,
  color: null,
  technical_file_url: "",
  comments_and_technical_file_requests: "",
  status: "",
  image_url: "",
  region: "",
  collection: null,
  artwork_name: null,
  artwork_number: null,
  molds: null,
  requestId: "",
  requestStatus: null,
  requestDateFrom: "",
  requestDateTo: "",
  requestor: "",
  requestHistory: [] as unknown as IMasterArtworkRequestHistory,
  submitComment: "",
  approveComment: "",
  rejectComment: "",
  rejectReason: null,
  hasUnsavedChanges: false,
  isValid: false,
  isReadOnly: false,
  purchasedPartOrSubAssembly: "N",
};

function reducer(
  state: MasterArtworkPrintingTechniqueState,
  action: MasterArtworkPrintingTechniqueActionType,
): MasterArtworkPrintingTechniqueState {
  switch (action.type) {
    case MasterArtworkPrintingTechniqueActionTypes.SET_PRINTING_TECHNIQUE:
      // @ts-ignore
      return action.payload;

    case MasterArtworkPrintingTechniqueActionTypes.RESET_STATE:
      // @ts-ignore
      return initialState;

    case MasterArtworkPrintingTechniqueActionTypes.SET_COLLECTION:
      return {
        ...state,
        collection: action.payload.collection ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_ID:
      return {
        ...state,
        id: action.payload.id,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_NAME:
      return {
        ...state,
        name: action.payload.name ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_DECORATION_TECHNIQUE:
      return {
        ...state,
        decoration_technique: action.payload.decoration_technique ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_COLOR:
      return {
        ...state,
        color: action.payload.color ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_TECHNICAL_FILE_URL:
      return {
        ...state,
        technical_file_url: action.payload.technical_file_url ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_COMMENTS_AND_TECHNICAL_FILE_REQUESTS:
      return {
        ...state,
        comments_and_technical_file_requests:
          action.payload.comments_and_technical_file_requests ?? "",
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_SUBMIT_COMMENT:
      return {
        ...state,
        submitComment: action.payload.submitComment ?? "",
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_APPROVE_COMMENT:
      return {
        ...state,
        approveComment: action.payload.approveComment ?? "",
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_REJECT_COMMENT:
      return {
        ...state,
        rejectComment: action.payload.rejectComment ?? "",
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_REJECT_REASON:
      return {
        ...state,
        rejectReason: action.payload.rejectReason ?? null,
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_IMAGE_URL:
      return {
        ...state,
        image_url: action.payload.image_url ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_REGION:
      return {
        ...state,
        region: action.payload.region ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_ARTWORK_NAME:
      return {
        ...state,
        artwork_name: action.payload.artwork_name ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_ARTWORK_NUMBER:
      return {
        ...state,
        artwork_number: action.payload.artwork_number ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_MOLDS:
      return {
        ...state,
        molds: action.payload.molds ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_REQUEST_ID:
      return {
        ...state,
        requestId: action.payload.requestId ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: action.payload.requestStatus ?? null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_REQUEST_DATE_FROM:
      return {
        ...state,
        requestDateFrom: action.payload.requestDateFrom ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_REQUEST_DATE_TO:
      return {
        ...state,
        requestDateTo: action.payload.requestDateTo ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_REQUESTOR:
      return {
        ...state,
        requestor: action.payload.requestor ?? "",
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_IS_VALID:
      return {
        ...state,
        isValid: action.payload.isValid || null,
      };
    case MasterArtworkPrintingTechniqueActionTypes.SET_IS_READ_ONLY:
      return {
        ...state,
        isReadOnly: action.payload.isReadOnly ?? false,
      };

    case MasterArtworkPrintingTechniqueActionTypes.SET_UNSAVED_CHANGES:
      return {
        ...state,
        hasUnsavedChanges: action.payload.hasUnsavedChanges || false,
      };

    // case MasterArtworkPrintingTechniqueActionTypes.SET_REQUEST_STATUS:
    //   return {
    //     ...state,
    //     requestStatus: action.payload.requestStatus ?? null,
    //   };

      case MasterArtworkPrintingTechniqueActionTypes.SET_PURCHASED_PART_OR_SUB_ASSEMBLY:
      return {
        ...state,
        purchasedPartOrSubAssembly: action.payload.purchasedPartOrSubAssembly ?? null,
      };
  }
  return state;
}

export const isStateEqualToInitialState = (state: MasterArtworkPrintingTechniqueState): boolean => {
  return Object.keys(initialState).every(
    (key) =>
      initialState[key as keyof MasterArtworkPrintingTechniqueState] ===
      state[key as keyof MasterArtworkPrintingTechniqueState],
  );
};

export const MasterArtworkPrintingTechniqueReducer = { initialState, reducer };
